import { createStore } from '../../../../core/utils/stateManagers';

// 쿼리 스토어 상태 인터페이스
export interface QueryState {
    searchQuery: string;
}

// 초기 상태
const initialState: QueryState = {
    searchQuery: '',
};

// 쿼리 스토어 생성
export const createQueryStore = () => {
    const store = createStore<QueryState>(initialState);

    return {
        ...store,

        // 검색어 설정
        setSearchQuery: (query: string) => store.update(state => ({ ...state, searchQuery: query })),

        // 스토어 초기화
        reset: () => store.set(initialState),
    };
};

// 싱글톤 인스턴스 생성 및 내보내기
export const searchQueryStore = createQueryStore();
